import { installDomTranslationGuard } from './lib/domTranslationGuard'
import { loadRuntimeConfig } from './config/env'

// Schutz gegen Browser-Übersetzungs-Crashes VOR dem ersten React-Mount aktivieren.
installDomTranslationGuard()

// Load /config.json BEFORE any other module is imported.
// All subsequent imports (App, api/*, etc.) see the runtime apiBaseUrl.
await loadRuntimeConfig()
await import('./bootstrap')
